export const accordionItemClasses = 'border-b';

export const accordionHeaderClasses = 'flex';

export const accordionTriggerClasses =
  'flex flex-1 items-center justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180';

export const accordionTriggerIconClasses =
  'size-4 shrink-0 transition-transform duration-200';

export const accordionContentClasses =
  'overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down';

export const accordionContentInnerClasses = 'pb-4 pt-0';
